import Interfaces from '../_interfaces';

export function StartKshProcessLevelSummaryCallback() {
    setKsh1081ProcessLevelQueryBtnDisabledState(true);
    const gridView: MVCxClientGridView = window["Ksh1081ProcessLevelSummary"];

    gridView.Refresh();
}

export function OnKsh1081ProcessLevelSummaryBeginCallback(s: ASPxClientRichEdit, e: MVCxClientBeginCallbackEventArgs) {
    e.customArgs['request'] = getKsh1081ProcessLevelRequest();
}

export function OnKsh1081ProcessLevelSummaryEndCallback() {
    setKsh1081ProcessLevelQueryBtnDisabledState(false);
}

function setKsh1081ProcessLevelQueryBtnDisabledState(isDisabled: boolean) {
    const $btn: JQuery<HTMLElement> = $('#ksh-process-level-fetch-btn');
    $btn.prop('disabled', isDisabled);
}

function getKsh1081ProcessLevelRequest(): Interfaces.KshProcessLevelSummaryRequest {
    let year: number = $('#year-selector').val() as number;
    let month: number = $('#month-selector').val() as number;
    let areaId: number = $('#area-selector').val() as number;
    let settlementName: string = $('#settlement-name').val() as string;

    const request: Interfaces.KshProcessLevelSummaryRequest = {
        year: year,
        month: month,
        areaId: areaId,
        settlementName: settlementName
    };

    return request;
}

$(document).on('click', '#ksh-process-level-fetch-btn', () => {
    StartKshProcessLevelSummaryCallback();
});
